/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Start_Aria_LabelInputs */

const en_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chain to Previous Event`)
};

const fr_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enchainer a l'Evenement Precedent`)
};

const de_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zum vorherigen Ereignis herstellen`)
};

const it_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concatena all'evento precedente`)
};

const ru_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цепочка к предыдущему событию`)
};

const es_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadena al evento anterior`)
};

const zh_cn2_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链至上一个事件`)
};

const ja_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のイベントへのチェーン`)
};

const hi_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली घटना से जुड़ी कड़ी`)
};

const pt_pt2_snap_to_start_aria_label = /** @type {(inputs: Snap_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadeamento ao evento anterior`)
};

/**
* | output |
* | --- |
* | "Chain to Previous Event" |
*
* @param {Snap_To_Start_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_start_aria_label = /** @type {((inputs?: Snap_To_Start_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Start_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_start_aria_label(inputs)
	if (locale === "de") return de_snap_to_start_aria_label(inputs)
	if (locale === "it") return it_snap_to_start_aria_label(inputs)
	if (locale === "ru") return ru_snap_to_start_aria_label(inputs)
	if (locale === "es") return es_snap_to_start_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_start_aria_label(inputs)
	if (locale === "ja") return ja_snap_to_start_aria_label(inputs)
	if (locale === "hi") return hi_snap_to_start_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_start_aria_label(inputs)
	return en_snap_to_start_aria_label(inputs)
});